export class BuyBonusButtonConstants {
    public static readonly BUY_TEXT_ID: string = 'buyButtonBuyTXT';
    public static readonly BONUS_TEXT_ID: string = 'buyButtonBonusTXT';
    public static readonly PLAY_TEXT_ID: string = 'buyButtonPlayTXT';
    public static readonly SPINE_NAME: string = 'buy_bonus_button';
    public static readonly CLICK_ANIMATION_NAME: string = 'press';
    public static readonly COIN_LAND_ANIMATION_NAME: string = 'coin_in';
}